import { DynamicDecorator } from '../../DynamicDecorator/DynamicDecorator';

export const BlogDecorator = () => (
  <>
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-airborne absolute right-10 top-2 h-3 w-3 md:right-16 md:top-6 md:h-4 md:w-4"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-butterscotch absolute right-5 top-5 h-6 w-6 md:right-10 md:top-10"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-primary-600 absolute bottom-[40%] left-4 h-[17px] w-[17px] md:bottom-4 md:left-14 md:h-6 md:w-6"
    />
    <DynamicDecorator
      decorator="halfStadium"
      className="text-naturaily-butterscotch absolute -bottom-4 -left-2 hidden h-12 w-12 rotate-180 md:block"
    />
  </>
);
